<div
  class="notice"
  role="alert"
  *ngIf="deviates && !dismissed"
>
  <p class="notice-text">
    Die hier angezeigte Datenschutzerklärung ist nicht die aktuell gültige Fassung. Bitte laden Sie
    die Seite neu, damit die geltende Fassung angezeigt wird.
  </p>
  <p
    class="notice-text"
    *ngIf="showSupportHint"
  >
    Der Hinweis erscheint weiterhin? Dann lässt sich das nicht durch Neuladen beheben. Bitte wenden
    Sie sich an den Benutzerservice.
  </p>
  <div class="notice-actions">
    <jf-button
      variant="primary"
      icon="refresh"
      iconPosition="left"
      text="Seite neu laden"
      (doClick)="reload()"
    ></jf-button>
    <jf-button
      variant="ghost"
      text="Hinweis ausblenden"
      (doClick)="dismiss()"
    ></jf-button>
  </div>
</div>

<!--
  Mit Beschriftung statt als bloßes Symbol: Ein Symbol allein lässt weder erkennen, dass es ein
  Knopf ist, noch wohin er führt - und es ist der einzige Weg zurück zum weggeklickten Hinweis.
-->
<jf-button
  class="notice-reopen"
  variant="outline"
  icon="warning"
  iconPosition="left"
  text="Hinweis zur abweichenden Fassung anzeigen"
  *ngIf="deviates && dismissed"
  (doClick)="reopen()"
></jf-button>
